'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys3 = require('babel-runtime/core-js/object/keys');

var _keys4 = _interopRequireDefault(_keys3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assign = _assign2.default; // An improved version of recompose withHandlers.
// The handlers are never regenerated; instead, they receive the latest
// props as an arg when they are invoked.

exports.default = function withConstHandlers(handlers) {
  return function (NextComponent) {
    var withConstHandlers = function (_React$Component) {
      (0, _inherits3.default)(withConstHandlers, _React$Component);

      function withConstHandlers(props) {
        (0, _classCallCheck3.default)(this, withConstHandlers);

        var _this = (0, _possibleConstructorReturn3.default)(this, (withConstHandlers.__proto__ || (0, _getPrototypeOf2.default)(withConstHandlers)).call(this, props));

        _this.handlers = function () {
          var _obj = {};

          var _loop = function _loop(_i2, _keys2, _len2) {
            var k = _keys2[_i2];
            var f = handlers[k];

            _obj[k] = function () {
              for (var _len3 = arguments.length, args = Array(_len3), _key = 0; _key < _len3; _key++) {
                args[_key] = arguments[_key];
              }

              return f.apply(undefined, [_this.props].concat(args));
            };
          };

          for (var _i2 = 0, _keys2 = (0, _keys4.default)(handlers), _len2 = _keys2.length; _i2 < _len2; _i2++) {
            _loop(_i2, _keys2, _len2);
          }

          return _obj;
        }();

        return _this;
      }

      (0, _createClass3.default)(withConstHandlers, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(NextComponent, assign({}, this.props, this.handlers));
        }
      }]);
      return withConstHandlers;
    }(_react2.default.Component);

    return withConstHandlers;
  };
};